window.tfGetVariantImage = function(product, colorValue) {
  var variants = product.variants || [];
  var variant = variants.find(function(v) {
    return v.option1 === colorValue;
  });
  if (!variant) return 'none';

  if (variant.featured_image && variant.featured_image.src) {
    var src1 = variant.featured_image.src;
    return 'url(' + src1 + (src1.indexOf('?') !== -1 ? '&' : '?') + 'width=80)';
  }

  if (product.images) {
    var img = product.images.find(function(image) {
      return image.variant_ids && image.variant_ids.indexOf(variant.id) !== -1;
    });
    if (img && img.src) {
      var src2 = img.src;
      return 'url(' + src2 + (src2.indexOf('?') !== -1 ? '&' : '?') + 'width=80)';
    }
  }

  return 'none';
};

(function() {
  function initRebuyButtons() {
    document.querySelectorAll('.rebuy-product-actions .rebuy-button, .rebuy-modal-actions .rebuy-button').forEach(function(btn) {
      if (btn.dataset.rebuyInit) return;
      btn.dataset.rebuyInit = '1';

      btn.addEventListener('mouseenter', function() {
        clearTimeout(this._rebuyResetTimer);
        this.style.setProperty('--rebuy-fill-transition', 'none');
        this.style.setProperty('--rebuy-fill', '76%');
        this.offsetHeight;
        this.style.setProperty('--rebuy-fill-transition', '0.5s cubic-bezier(.3, 1, .3, 1)');
        this.style.setProperty('--rebuy-fill', '0%');
        this.classList.add('is-hovered');
      });

      btn.addEventListener('mouseleave', function() {
        var self = this;
        self.style.setProperty('--rebuy-fill-transition', '0.5s cubic-bezier(.3, 1, .3, 1)');
        self.style.setProperty('--rebuy-fill', '-76%');
        self.classList.remove('is-hovered');
        self._rebuyResetTimer = setTimeout(function() {
          self.style.setProperty('--rebuy-fill-transition', 'none');
          self.style.setProperty('--rebuy-fill', '76%');
        }, 500);
      });
    });
  }

  var observer = new MutationObserver(initRebuyButtons);
  observer.observe(document.body, { childList: true, subtree: true });
  initRebuyButtons();
})();